import routes from './routes';

export const PAGE_TITLES: Record<string, string> = {
    [routes.DASHBOARD]: '',

    // Providers
    // [routes.PROVIDERS_LIST]: 'Providers',
    // [routes.PROVIDER_CREATE]: 'Create Provider',
    // [routes.PROVIDER_EDIT]: 'Edit Provider',
    // [routes.PROVIDER_DETAIL]: 'Provider Details',

    // Orders
    /*[routes.ORDERS_LIST]: 'Orders',
    [routes.ORDER_CREATE]: 'Create Order',
    [routes.ORDER_EDIT]: 'Edit Order',
    [routes.ORDER_DETAIL]: 'Order Details',*/

    // Program Book
    /*[routes.PROGRAM_BOOK_CREATE]: 'Program Book',
    [routes.PROGRAM_BOOK_TARGET_CREATE]: 'Program Book Target',*/

    // Auth
    /*[routes.LOGIN_CUSTOMER]: 'Login',
    [routes.LOGIN_CODE]: 'Login Code',*/
};
